import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { EnvelopeSimple, CheckCircle, CircleNotch } from "@phosphor-icons/react";

// Reusable launch-waitlist form. `dark` matches the marketing theme; light suits the dashboard.
export default function Waitlist({ country, countryName, plan = null, dark = true }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!email || !email.includes("@")) { toast.error("Enter a valid email address"); return; }
    setBusy(true);
    try {
      await api.post("/waitlist", { email: email.trim(), country: country || null, plan: plan || null });
      setDone(true);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const region = countryName || "your region";

  if (done) {
    return (
      <div className={`flex items-start gap-2.5 text-sm ${dark ? "text-primary" : "text-emerald-700"}`} data-testid="waitlist-success">
        <CheckCircle size={20} weight="fill" className="shrink-0 mt-0.5" />
        <span>You're on the list. We'll email you the moment paid plans launch in {region}.</span>
      </div>
    );
  }

  const inputCls = dark
    ? "flex-1 min-w-0 bg-white/5 border border-white/15 rounded-full text-white text-sm px-4 py-2.5 placeholder:text-white/35 focus:outline-none focus:border-primary/60"
    : "flex-1 min-w-0 bg-white border border-slate-300 rounded-full text-slate-800 text-sm px-4 py-2.5 placeholder:text-slate-400 focus:outline-none focus:border-primary";

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2" data-testid="waitlist-form">
      <div className="relative flex-1 min-w-0">
        <EnvelopeSimple size={16} className={`absolute left-3.5 top-1/2 -translate-y-1/2 ${dark ? "text-white/40" : "text-slate-400"}`} />
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com" aria-label={`Email for ${region} waitlist`}
          className={`${inputCls} pl-9`} data-testid="waitlist-email-input"
        />
      </div>
      <Button type="submit" disabled={busy} className={`rounded-full shrink-0 ${dark ? "bg-primary text-[#2a2d31] font-semibold hover:bg-primary/90" : ""}`} data-testid="waitlist-submit">
        {busy ? <CircleNotch className="animate-spin" size={16} /> : "Join the waitlist"}
      </Button>
    </form>
  );
}
